/* eslint-disable */
export default {
	TOGGLE_LOADING (state) {
		state.callingAPI = !state.callingAPI
	},
	TOGGLE_SEARCHING (state) {
		state.searching = (state.searching === '') ? 'loading' : ''
	},
	SET_USER (state, user) {
		state.user = user
	},
	SET_TOKEN (state, token) {
		state.token = token
	},
	ADD_PRODUCTO (state, producto) {
		state.productos.push(producto)
	},
	CLEAR_PRODUCTOS (state, producto) {
		state.productos = []
	},
	SYNC_PRODUCTO (state, productos) {
		state.productos = productos
	},
	ADD_ETIQUETA (state, etiqueta) {
		state.etiquetas.push(etiqueta)
	},
	CLEAR_ETIQUETAS (state, etiqueta) {
		state.etiquetas = []
	},
	SYNC_ETIQUETA (state, etiquetas) {
		state.etiquetas = etiquetas
	},
	ADD_MOVIMIENTO (state, movimiento) {
		state.movimientos.push(movimiento)
	},
	CLEAR_MOVIMIENTOS (state, movimiento) {
		state.movimientos = []
	},
	SYNC_MOVIMIENTO (state, movimientos) {
		state.movimientos = movimientos
	},
	SYNC_PENDIENTES (state, asset) {
		state.pendientes[asset] = state.pendientes[asset] === 0 ? 1 : 0
	},
	SYNC_ONLINE (state, value) {
		state.online = value
	}
}



// WEBPACK FOOTER //
// ./src/store/mutations.js